exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-tagsell[data-v-4583b18e]{background-color:#ed1763;color:#fff}@media screen and (max-width:768px){.btn-tagsell[data-v-4583b18e]{display:block;width:100%}}.panel-body p[data-v-4583b18e]{color:#7b7b7b;font-size:1.2em;margin-top:15px;font-weight:500}.d-flex[data-v-4583b18e]{display:flex}.justify-center[data-v-4583b18e]{justify-content:center}.activate-button-div[data-v-4583b18e]{margin:20px 0}.success-message[data-v-4583b18e]{display:flex;justify-content:center;align-items:center;font-size:1.2em;margin-top:15px;color:#7accbe!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4583b18e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/ModalRegisterStore.vue
// module id = B+tW
// module chunks = 101 104